import { ChangeDetectionStrategy, Component, input, InputSignal } from "@angular/core";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-loader",
  imports: [SvgIconComponent],
  templateUrl: "./loader.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./loader.component.scss",
})
export class LoaderComponent {
  public readonly fullScreen: InputSignal<boolean | undefined> = input<boolean | undefined>(true);
  public readonly backdrop: InputSignal<boolean | undefined> = input<boolean | undefined>(true);
}
